import React, { Component } from 'react';
import '../App.css';

class Question extends Component{
    constructor(props) {
        super(props);
        this.state = {
           correctAnswer: '',
           options: []
          };
    }

    componentDidMount(){     
        const {incorrect_answers, correct_answer} =  this.props.question;
        let options = [correct_answer, ...incorrect_answers]
        options.forEach((option)=>{
            option.replace(/(&quot;)/g,'"').replace(/(&#039;)/g, "'")
        })
        this.setState({
            options: this.shuffle(options)
        })
        this.setState({correctAnswer: this.props.question.correct_answer})
    }

    shuffle(array) {
        let currentIndex = array.length;
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
      
          // Pick a remaining element...
          let randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
          [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }
      
        return array;
      }
      

    handleClick = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        
        this.setState({
          [name]: value
        });
        const questionNum = `question${this.props.questionID}`
        const optionValue = document.querySelector(`input[name = ${questionNum}]:checked`).value;
        const {correctAnswer} = this.state;
        const {addCorrectAttempts, questionID} = this.props;
        if(optionValue===correctAnswer){
            addCorrectAttempts(optionValue, correctAnswer,  1, questionID)
        } else{
            addCorrectAttempts(optionValue, correctAnswer, 0, questionID)
        }
      }

    render(){
        const {question, type} =  this.props.question;
        const {questionID} = this.props;
        return(
            <div className = "Question">
               <p>Question {questionID+1}: &nbsp; {question.replace(/(&quot;)/g,'"').replace(/(&#039;)/g, "'")}</p>
               {type==='boolean' ?(
                <div>
                    <div className="radio-inline">
                        <label>
                            <input type="radio" name={`question${questionID}`} 
                            onClick ={this.handleClick} 
                            value ='False'/>False
                        </label>
                    </div>
                    <div className="radio-inline">
                        <label>
                            <input type="radio" name={`question${questionID}`} 
                            onClick ={this.handleClick} 
                            value ='True'/>True
                        </label>
                    </div>
                    <hr></hr>
                </div>
               ):(
                <div>               
                    <div className="radio-inline">
                        <label>
                            <input 
                                type="radio" 
                                name={`question${questionID}`} 
                                onClick ={this.handleClick} 
                                value ={this.state.options[0]}
                            />
                                {this.state.options[0]}
                        </label>
                    </div>
                    <div className="radio-inline">
                        <label>
                            <input 
                                type="radio" 
                                name={`question${questionID}`}
                                onClick ={this.handleClick}
                                value ={this.state.options[1]} 
                            />
                                {this.state.options[1]}
                        </label>
                    </div>
                    <div className="radio-inline">
                        <label>
                            <input 
                                type="radio" 
                                name={`question${questionID}`}
                                onClick ={this.handleClick}
                                value ={this.state.options[2]} 
                            />
                            {this.state.options[2]}
                        </label>
                    </div>
                    <div className="radio-inline">
                        <label>
                            <input 
                                type="radio" 
                                name={`question${questionID}`}
                                onClick ={this.handleClick} 
                                value ={this.state.options[3]}/>{this.state.options[3]}
                        </label>
                    </div>             
                    <hr></hr>
                </div>
               )}
            </div>
        )
    }
}

export default Question;